import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { some } from "lodash";
import api from "APP_ROOT/api";
import { addressesToOptions } from "LIB/forms";
import * as actions from "MODULES/RepairOrders/actions";
import * as companyActions from "MODULES/companies/actions";
import { form, Form as AppForm, Select } from "MODULES/shared/components/Forms";
import SearchCompany from "MODULES/companies/shared/FindOrCreateCompanyToggle/SearchCompany";
import CompanyAddressWarning from "MODULES/shared/components/CompanyAddressWarning";
import { searchContacts } from "MODULES/parts/actions";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import { COMPANY } from "MODULES/companies/constants";
import { ID } from "APP_ROOT/constants";

const formName = "updateRepairOrder";

class EditCompanyForm extends React.Component {
  constructor() {
    super();
    this.notifyForm = this.notifyForm.bind(this);
  }

  state = {
    contacts: [],
    invalidCompany: false,
    primaryPhysicalAddress: { value: "", text: "" },
    selectedCompany: null
  };

  componentWillMount() {
    if (this.props.record.get(COMPANY)) {
      this.fetchContacts(this.props.record.getIn([COMPANY, ID]));
      this.fetchAddresses(this.props.record.getIn([COMPANY, ID]));
    }
  }

  notifyForm = company => {
    if (
      company &&
      (!company.primary_physical_address || !company.billing_address)
    ) {
      return this.setState({ invalidCompany: true, company });
    }
    return this.setState({ invalidCompany: false });
  };

  handleCompanySelected = company => {
    this.setState({ selectedCompany: company });
    this.fetchAddresses(company.id);
  };

  fetchAddresses = companyId => {
    api.companies.physicalAddresses
      .search(companyId, {
        page: 1,
        limit: 100,
        sort: "primary",
        reverse: true
      })
      .then(resp => {
        if (resp.data.results.length > 0) {
          const primaryAddress = resp.data.results[0];
          this.setState({
            primaryPhysicalAddress: addressesToOptions([primaryAddress])[0]
          });
          this.props.change(
            "repair_station_physical_address_id",
            primaryAddress.id
          );
        } else {
          this.setState({ primaryPhysicalAddress: { value: "", text: "" } });
        }
      });
  };

  fetchContacts = value => {
    if (!value) {
      return null;
    }
    return searchContacts(value).then((vals = []) =>
      this.setState({ contacts: vals })
    );
  };

  render() {
    const { record } = this.props;
    const {
      invalidCompany,
      selectedCompany,
      primaryPhysicalAddress
    } = this.state;
    const company =
      selectedCompany || (record.get(COMPANY) && record.get(COMPANY).toJS());
    const hasShippedLineItems = some(
      record.get("line_items").toJS(),
      lineItem => lineItem.shipped
    );

    return (
      <AppForm {...this.props} disabled={invalidCompany}>
        <AppForm.Body>
          <CompanyAddressWarning company={company} />
          <SearchCompany
            companySearch={companyActions.searchRepairStationCompanies}
            contacts={this.state.contacts}
            formName={formName}
            fetchContacts={this.fetchContacts}
            selectedCompany={company}
            onCompanySelected={this.handleCompanySelected}
            onCompanyToggleTypeChange={this.handleToggleChange}
            type="repairOrder"
            disabledFields={{ company_id: hasShippedLineItems }}
          />
          <FormRow>
            <Col md={6}>
              <div className="form-group">
                <Field
                  name="repair_station_physical_address_id"
                  label="Repair Station Address"
                  component={Select}
                  value={primaryPhysicalAddress}
                  options={[primaryPhysicalAddress]}
                  prompt={false}
                  disabled
                  required
                />
              </div>
            </Col>
          </FormRow>
        </AppForm.Body>
      </AppForm>
    );
  }
}

EditCompanyForm.propTypes = {
  change: PropTypes.func.isRequired,
  record: PropTypes.func.isRequired
};

export default connect(undefined, { onSubmit: actions.update })(
  form({
    form: formName
  })(EditCompanyForm)
);



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Edit/EditCompanyForm.jsx